export default "__VITE_ASSET__BByoHkE3__"